import React, { useContext, useEffect, useState } from "react";
import AppSpinner from "./AppSpinner"; // Import AppSpinner component
import PlatformLogo from "./PlatformLogo"; // Import PlatformLogo component
import Cookies from "universal-cookie";
import { useHistory } from "react-router-dom";
import Api_Call from "../ApiCall";
import UserContext from "../components/Common/UserContext";
import menus from "../user-config.json";
import BackdropLoading from "../components/Common/BackdropLoading";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import axios from "axios";
import Info from "../info.json";

const TokenFetchingPage = () => {
  const [message, setMessage] = useState("Message");
  const [loading, setLoading] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [errorLogin, setErrorLogin] = useState("");

  const {
    userRole,
    setUserName: setDiaplayUserName,
    setUserRole,
    userId,
    setUserId,
    setAccessToken,
    setPassChangeRequired,
    setIsPresenter,
    isPresenter,
  } = useContext(UserContext);
  const history = useHistory();
  const location = useLocation();
  //========================Read From Cookie====================
  console.log("Token fetching page");
  const AuthenticateUser = async () => {
    const searchParams = new URLSearchParams(location.search);
    const jwtToken = searchParams.get("token");

    const api = new Api_Call();

    const data = await api.postData(`GET-PUBLIC-KEY`, { jw_token: jwtToken });
    console.log(data.success);

    if (data.success) {
      //Get Username with string operations
      // setUserName(data.body.unique_name);
      var instance = Info.INSTACE;
      if (instance === "DEMO") {
        console.log(
          "Received success from API with email ",
          data.body.unique_name
        );
        signInHandler(data.body.unique_name);
      } else {
        history.push("/Login");
      }
    } else {
      history.push("/AccessDenied");
    }
  };

  //Api Call ==============================================================================================
  const signInHandler = async (userName) => {
    console.log("In function signInHandler() , username ", userName);
    if (userName === "") return;

    try {
      setLoading(true);

      const api = new Api_Call();
      const data = await api.postData("/USER/LOGIN", {
        user_name: userName,
      });
      if (data.statusCode !== 200) {
        // throw new Error(data.body);
        history.push("/AccessDenied");
      }

      //Set User Identifiers ==============================================================================================
      setUserId(data.body["user_id"]);
      // Nurse,supervisor=1; auditor,intake,admin=0
      setDiaplayUserName(data.body["name"]);
      sessionStorage.setItem("Name", data.body["name"]);
      sessionStorage.setItem("userName", userName);
      sessionStorage.setItem("userRoleId", data.body["role_id"]);
      setUserRole(data.body["user_role"]);

      sessionStorage.setItem("userRole", data.body["user_role"]);

      if (data.body["user_role"] == "Presenter") {
        setIsPresenter(true);
        sessionStorage.setItem("isPresenter", true);
      }
      sessionStorage.setItem("UserID", data.body["user_id"]);

      sessionStorage.setItem(
        "Clinical",
        menus[data.body["user_role"].toLowerCase()]["clinical"]
      );

      sessionStorage.setItem(
        "RedirectPage",
        menus[data.body["user_role"].toLowerCase()]["menus"].find(
          (item) => item.landingPage === true
        )["route"]
      );

      // if (data.body["password_change_required"]) {
      //   history.push("/ChangePassword");
      //   return;
      // }

      // //Redirection(role based)==============================================================================================
      // else {
      // setUserRole(data.body["user_role"]);

      // sessionStorage.setItem("userRole", data.body["user_role"]);
      // sessionStorage.setItem("UserID", data.body["user_id"]);

      // sessionStorage.setItem(
      //   "Clinical",
      //   menus[data.body["user_role"].toLowerCase()]["clinical"]
      // );

      history.push(
        menus[data.body["user_role"].toLowerCase()]["menus"].find(
          (item) => item.landingPage === true
        )["route"]
      );
      // }
    } catch (error) {
      setErrorLogin(error.message);
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  };

  const encrypt = (message, publicKey) => {
    // const jsEncrypt = new JSEncrypt();
    // jsEncrypt.setPublicKey(publicKey);
    // return jsEncrypt.encrypt(message);
  };

  const ValidateToken = async (token, issuer, audience, JwtSecurityToken) => {
    // const api = new Api_Call();
    // const data = await api.getData(`GET-PUBLIC-KEY`);
    // const xmlKey = data.body;
    // const rsaSecurityKey = xmlKey;

    // const rsaEnc = encrypt("Key", rsaSecurityKey);
    // console.log("rsaEnc", rsaEnc);
    // var validationParameters = new TokenValidationParameters();
    // {
    //   (ValidateIssuer = false),
    //     (ValidIssuer = issuer),
    //     (ValidateAudience = false),
    //     (ValidAudience = audience),
    //     (ValidateIssuerSigningKey = true),
    //     (IssuerSigningKey = rsaSecurityKey),
    //     (ValidateLifetime = true);
    // }
    return true;
  };

  // // Extract query parameters
  // const queryParameters = new URLSearchParams(location.search);
  // const appName = queryParameters.get("appName");
  const params = new URLSearchParams(window.location.search);

  // Get the value of a specific parameter, for example 'paramName'
  const appname = params.get("appname");
  const appInitials = params.get("appinitials");
  const platform = params.get("platform");

  useEffect(() => {
    AuthenticateUser();
  }, []);
  //   useEffect(() => {
  //     const script = document.createElement("script");
  //     script.src = "/public/jsencrypt.min.js";
  //     script.async = true;
  //     document.body.appendChild(script);
  //   }, [1]);

  return (
    <div>
      {/* <div>{message}</div> */}
      <AppSpinner
        options={{
          appInitials: appInitials,
          // appname: "appname",
          appname: appname,
          // Use appName extracted from query parameters
          platformName: platform,
          fileUrl: "",
        }}
      ></AppSpinner>
      <PlatformLogo
        appName={{ part1: "Digital", part2: "X-Studio" }}
        logoImgUrl={""}
      ></PlatformLogo>
    </div>
  );
};

export default TokenFetchingPage;
